/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_FeaturedInputs */

const cs_enum_featured = /** @type {(inputs: Enum_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zvýrazněné`)
};

const en_enum_featured = /** @type {(inputs: Enum_FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Enum_FeaturedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_featured = /** @type {((inputs?: Enum_FeaturedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_FeaturedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_featured(inputs)
	return cs_enum_featured(inputs)
});